<template>
  <footer
    class="bg-white text-black pt-16 md:pt-20 xl:pt-24"
  >
  	<div
      class="mx-4 lg:mx-20 xl:mx-40"
    >
      <div class="flex text-center">
        <div
          
        >
          
          <ul
            class="space-y-0 text-sm font-light pb-20 grid grid-cols-4 gap-y-4"
          >
            <li class="">
              <img src="/images/eronto.png" alt="Eronto" class="w-24 md:w-36 lg:w-48">
            </li>
            <li class="row-span-2">
              <ul class="space-y-4">
                <li>
                  <router-link
                    to="/"
                    class="transition duration-200 hover:underline"
                  >
                     {{ $t("navHeader.home")}}
                  </router-link>
                </li>
                <li>
                  <router-link
                    to="/about"
                    class="transition duration-200 hover:underline"
                  >
                    {{ $t("navFooter.aboutUs")}}
                  </router-link>
                </li>
                <li>
                  <a
                    href="https://my.eronto.io"
                    class="transition duration-200 hover:underline"
                  >
                    {{ $t("navFooter.tradingPlatform")}}
                  </a>
                </li>
              </ul>
            </li>
            <li
              class="row-span-2"
            >
              <ul
                class="space-y-4"
              >
                <li>
                  <router-link
                    to="/trading-academy/key-markets"
                    class="transition duration-200 hover:underline"
                  >
                    {{ $t("navFooter.tradingAcademy")}}
                  </router-link>
                </li>
                <li>
                  <router-link
                    to="/trading-academy/indicators"
                    class="transition duration-200 hover:underline"
                  >
                    {{ $t("navHeader.tradingAcademy.indicators")}}
                  </router-link>
                </li>
                <li>
                  <router-link
                    to="/trading-academy/fundamentals"
                    class="transition duration-200 hover:underline"
                  >
                    {{ $t("navHeader.tradingAcademy.fundamental")}}
                  </router-link>
                </li>
              </ul>
            </li>
            <li
              class="row-span-2"
            >
              <ul
                class="space-y-4"
              >
                <li>
                  <router-link
                    to="/legal/terms"
                    class="transition duration-200 hover:underline"
                  >
                    {{ $t("navFooter.legal")}}
                  </router-link>
                </li>
                <li>
                  <router-link
                    to="/contact"
                    class="transition duration-200 hover:underline"
                  >
                    {{ $t("navFooter.contactUs")}}
                  </router-link>
                </li>
                <li>
                  <a
                    href="https://my.eronto.io/register"
                    class="inline-block font-medium text-white bg-gradient-to-r from-primar-550 to-primar-400 hover:to-primar-400 text-base xl:text-base py-1 px-3 rounded-md shadow focus:ring-offset-blue-200  cursor-pointer"
                  >
                    {{ $t("homeView.joinNow")}}
                  </a>
                </li>
              </ul>
            </li>
            <li
              class="col-span-4 pt-14"
            >
              <p
                class="leading-6 lg:leading-7"
              >
                {{ $t("navFooter.textOne")}}<br>
                {{ $t("navFooter.textTwo")}}
              </p>
              <p
                class="leading-6 lg:leading-7"
              >
                {{ $t("navFooter.textThree")}}
              </p>
            </li>
            <li class="col-span-4 pt-2 m-auto">
              <a href="https://wa.me/442394200889"><img src="/images/wapp.webp" class="inline-block" width="38"/>&nbsp; +44 23 9420 0889</a>
            </li>
          </ul>
        </div>
        <div class="hidden md:w-1/3 space-y-4 mt-10 sm:mt-0">
          <h2
              class="text-sm font-semibold tracking-wide uppercase"
            >
               {{ $t("navFooter.subscribe")}}
            </h2>
            <p>  {{ $t("navFooter.theLatestNews")}}</p>
            <form
              role="form"
              @submit="onSubmit"
            >
              <div
                class="flex space-x-3"
              >
                <input
                  type="email"
                  v-model="email"
                  class="w-full py-2 px-4 bg-white shadow-md rounded-lg text-sm xl:text-base text-gray-900 placeholder-gray-400 border border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-blue-800"
                  placeholder="$t('homeView.startYourJourney')"

                />
                <button
                  type="submit"
                  v-if="!isSending"
                  class="flex-shrink-0 bg-blue-800 font-medium text-white text-sm xl:text-base py-2 px-4 rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-800 focus:ring-offset-2 focus:ring-offset-blue-200"
                >
                  Subscribe
                </button>
                <button
                  v-else
                  class="flex-shrink-0 bg-blue-800 font-medium text-white text-sm xl:text-base py-2 px-4 rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-800 focus:ring-offset-2 focus:ring-offset-blue-200"
                >
                  Sending...
                </button>
              </div>
              <div v-if="sentSuccess" class="flex items-center bg-green-500 text-white text-sm font-bold px-4 py-3 mt-4" role="alert">
                <svg class="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"/></svg>
                <p>You have successfully subscribed</p>
              </div>
            </form>
        </div>
      </div>
    </div>

    <cookie-law theme="base--rounded"
                buttonText="Got It!"
                position="bottom"
                transitionName="fade"
    >
      <div slot="message">
         {{ $t("navFooter.cookieDisclaimerMessage")}}
      </div>
    </cookie-law>
    <div class="fixed bottom-20 right-4">
      <a href="https://wa.me/442394200889"><img src="/images/wapp2.png" class="inline-block" width="42"/></a>
  </div>
  </footer>
  
</template>
<script>
const axios = require('axios');
import CookieLaw from 'vue-cookie-law'
export default {
  components: { CookieLaw },
  created() {
    
  },
  data() {
		return {
      email: '',
      sentSuccess: false,
      isSending: false
    };
	},
  methods: {
		clearForm() {
      this.sentSuccess = false;
			for (let field in this.contact) {
				this.contact[field] = ''
			}
		},
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
		onSubmit(evt) {
			evt.preventDefault();
			this.isSending = true;
			setTimeout(() => {
				let form = new FormData();
				form.append('email', this.email);
				axios.post('/api/public/newsletterForm', form).then((response) => {
					this.clearForm();
					this.isSending = false;
          this.sentSuccess = true;
				}).catch((e) => {
					console.log(e)
				});

			}, 1000);
		}
	}
};
</script>